export default "__VITE_ASSET__D1edU1A7__"